"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowStatus = void 0;
var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["Draft"] = "draft";
    WorkflowStatus["Published"] = "published";
})(WorkflowStatus = exports.WorkflowStatus || (exports.WorkflowStatus = {}));
//# sourceMappingURL=workflow-status.js.map